import {history} from 'client/history';

/**
 * @param questionSetSlug
 * @param questionSlug
 * @todo Ideally the callers of this function can just rely directly
 * on model/extension methods in the future (removing the need for this file).
 * @returns function to push to direct question link
 */
// eslint-disable-next-line import/prefer-default-export
export function makeNavigateToQuestion(questionSetSlug, questionSlug) {
  const splitSlug = questionSetSlug.split('@');
  const subjectSlug = splitSlug[0];
  return () => {
    history.pushState(null, `/learn/question/${subjectSlug}/${questionSlug}`);
  };
}
